export const fillStr = (
  v: number,
  period = 2,
  symbol = "0",
  pos: "bef" | "aft" = "bef"
): string => {
  let vStr = v + "";
  let zeroLack = vStr.length - period;

  if (zeroLack > 0) return vStr;

  while (zeroLack < 0) {
    if (pos === "bef") {
      vStr = symbol + vStr;
    } else if (pos === "aft") {
      vStr = vStr + symbol;
    }
    ++zeroLack;
  }

  return vStr;
};
